var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "admin" },
    [
      _c(
        "div",
        { staticClass: "content" },
        [
          _c("ZhjySerach", {
            attrs: { queryGroup: _vm.queryGroup, modelData: _vm.modelData },
            on: {
              "update:modelData": function ($event) {
                _vm.modelData = $event
              },
              "update:model-data": function ($event) {
                _vm.modelData = $event
              },
              search: _vm.list,
            },
          }),
          _vm._v(" "),
          _c("FunBtn", {
            attrs: {
              funBtns: _vm.funBtns,
              defaultColumn: _vm.defaultColumn,
              isShowSelectChange: true,
            },
            on: {
              prize: _vm.prize,
              unPublish: function ($event) {
                return _vm.publish(0)
              },
              publish: function ($event) {
                return _vm.publish(1)
              },
              assignExpert: _vm.assignExpert,
              matchdaochu: _vm.matchdaochu,
              load: _vm.load,
              deleteById: _vm.deleteById,
              sdfp: _vm.sdfp,
              getScore: _vm.getScore,
            },
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "admin-main" },
            [
              _c("ZhjyTable", {
                attrs: {
                  minWidth: _vm.minWidth,
                  tableData: _vm.tableData,
                  columList: _vm.defaultColumn,
                  isShowSelection: true,
                  options: _vm.options,
                  formatters: _vm.formatters,
                  pageNum: _vm.page.pageNum,
                  pageSize: _vm.page.pageSize,
                },
                on: {
                  "update:pageNum": function ($event) {
                    return _vm.$set(_vm.page, "pageNum", $event)
                  },
                  "update:page-num": function ($event) {
                    return _vm.$set(_vm.page, "pageNum", $event)
                  },
                  handleSelectionChange: _vm.handleSelectionChange,
                  audit: function ($event) {
                    return _vm.audit($event, 3)
                  },
                  unaudit: _vm.unaudit,
                  detail: _vm.detail,
                  allot: _vm.allot,
                  deleteById: _vm.deleteById,
                  comment: _vm.comment,
                  cszpPd: _vm.cszpPd,
                },
              }),
              _vm._v(" "),
              _c("ZhjyPagination", {
                attrs: {
                  pageNum: _vm.page.pageNum,
                  pageSize: _vm.page.pageSize,
                  total: _vm.total,
                },
                on: {
                  "update:pageNum": function ($event) {
                    return _vm.$set(_vm.page, "pageNum", $event)
                  },
                  "update:page-num": function ($event) {
                    return _vm.$set(_vm.page, "pageNum", $event)
                  },
                  handleCurrentChange: _vm.handleCurrentChange,
                  handleSizeChange: _vm.handleSizeChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "pubDia",
          attrs: {
            title: "设置奖项",
            visible: _vm.prizeDialogVisible,
            width: "30%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.prizeDialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            [
              _c(
                "el-form-item",
                { attrs: { label: "设置奖项" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择奖项" },
                      model: {
                        value: _vm.prizeValue,
                        callback: function ($$v) {
                          _vm.prizeValue = $$v
                        },
                        expression: "prizeValue",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: { label: "一等奖", value: "1" },
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { label: "二等奖", value: "2" },
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { label: "三等奖", value: "3" },
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { label: "未获奖", value: "0" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.prizeDialogVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.submitPrize } },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "sdfpDia pubDia",
          attrs: { title: "手动分配专家", visible: _vm.sdfpDia, width: "80%" },
          on: {
            "update:visible": function ($event) {
              _vm.sdfpDia = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { attrs: { "label-width": "100px" } },
            [
              _c("ZhjySerach", {
                attrs: {
                  queryGroup: _vm.noAssignQueryGroup,
                  modelData: _vm.noAssignModelData,
                },
                on: {
                  "update:modelData": function ($event) {
                    _vm.noAssignModelData = $event
                  },
                  "update:model-data": function ($event) {
                    _vm.noAssignModelData = $event
                  },
                  search: _vm.noAssignSearch,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("ZhjyTable", {
            attrs: {
              tableData: _vm.noAssignTableData,
              columList: _vm.defaultColumn2,
              isShowSelection: true,
              formatters: _vm.formatters2,
              pageNum: _vm.noAssignPage.pageNum,
              pageSize: _vm.noAssignPage.pageSize,
            },
            on: {
              "update:pageNum": function ($event) {
                return _vm.$set(_vm.noAssignPage, "pageNum", $event)
              },
              "update:page-num": function ($event) {
                return _vm.$set(_vm.noAssignPage, "pageNum", $event)
              },
              handleSelectionChange: _vm.noAssignHandleSelectionChange,
            },
          }),
          _vm._v(" "),
          _c("ZhjyPagination", {
            attrs: {
              pageNum: _vm.noAssignPage.pageNum,
              pageSize: _vm.noAssignPage.pageSize,
              total: _vm.noAssignTotal,
            },
            on: {
              "update:pageNum": function ($event) {
                return _vm.$set(_vm.noAssignPage, "pageNum", $event)
              },
              "update:page-num": function ($event) {
                return _vm.$set(_vm.noAssignPage, "pageNum", $event)
              },
              handleCurrentChange: _vm.noAssignHandleCurrentChange,
              handleSizeChange: _vm.noAssignHandleSizeChange,
            },
          }),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.IsSdfp } },
                [_vm._v("确 定")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.sdfpDia = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }